import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class DomainService {

  private _isCustomBrand: BehaviorSubject<Boolean> = new BehaviorSubject(false);
  public isCustomBrand$ = this._isCustomBrand.asObservable();
  private brandDomains = ['localhost:4201', 'dev.evaluapsi.pages.dev', 'mievaluado.com']
  public uid = '';
  private _customColor: BehaviorSubject<string> = new BehaviorSubject('');
  public customColor$ = this._customColor.asObservable();
  private _logoUrl: BehaviorSubject<String> = new BehaviorSubject('');
  public logoUrl$ = this._logoUrl.asObservable();
  private _logoLink: BehaviorSubject<String> = new BehaviorSubject('');
  public logoLink$ = this._logoLink.asObservable();
  public _inCustomDomain$ = new BehaviorSubject(false);
  public inCustomDomain$ = this._inCustomDomain$.asObservable();

  public customColor = '';
  public logoUrl = '';

  constructor(
    private userService: UserService,
    private titleService: Title
  ) {
  }

  public inirService(){
    this.uid = localStorage.getItem("uid");
    this._inCustomDomain$.next(this.brandDomains.includes(window.location.host))
    if (this.brandDomains.includes(window.location.host)){
      this.titleService.setTitle('Mi evaluado')
    }
    if (!this.uid) return
    this._isCustomBrand.next(this.uid != null)
    if (this._isCustomBrand.value){
      this.userService.getUserByQuery({_id: this.uid}).subscribe(
        resp => {
          if (!resp.isCustomBrand || resp.role == 'admin'){
            console.log('is admin')
            this._isCustomBrand.next(false);
            return
          }
          this._customColor.next(resp.customColor)
          this._logoUrl.next(resp.logoUrl)
          this.customColor = resp.customColor
          this.logoUrl = resp.logoUrl
          this._logoLink.next(resp.logoLink)
        },
        err => {
          console.log(err);
          this._isCustomBrand.next(false);
        }
      )
    }
  }
}
